import $ from "jquery"
import  MySecurityClass from "./MySecurityClass"

class OnlineEncrypt {

  constructor(o){
    this.type = o.type;
    this.encButton = o.encButton;
    this.decButton = o.decButton;
    this.encryptedField = o.encryptedField;
    this.decryptedField = o.decryptedField
    console.log("ich bin im OnlineEncrypt() constructor");
    this.events()
  }
  //events
  events(){
    console.log("ich bin im events()");
    this.encButton.on("click", this.encrypt.bind(this))
    this.decButton.on("click", this.decrypt.bind(this))   
  }
  //callbacks, methods
  encrypt(){
    console.log("ich bin im encrypt()");
    //read input field decryptedField
    var decryption = this.decryptedField.val();
    console.log("decryption: " + decryption);
     //encrypt it 
    let encryption = this.type === "email" ? MySecurityClass.rot13(decryption) : MySecurityClass.rot5(decryption);
    //write to encryptedEmailField
     this.encryptedField.val(encryption)
  }
  decrypt(){
    console.log("ich bin im decrypt()");
    //read input field encryptedField
    var encryption = this.encryptedField.val();
    console.log("encryption: " + encryption);
     //encrypt it 
    let decryption  = this.type === "email" ? MySecurityClass.rot13(encryption) : MySecurityClass.rot5(encryption);
    //write to encryptedField
     this.decryptedField.val(decryption)
  }

}

export default OnlineEncrypt

